// =============================================================
// 店頭iPad / QR連携（kiosk）
// 既存の tshirt-designer.js（エディタ本体）に被せる連携モジュール。
// フロー: kiosk_tokenゲート → サイズ選択 → 依頼作成API → デザイン作成
//         → 「この内容で決定」→ 画像生成 → アップロードAPI → QR表示
// ※ kiosk_token は localStorage のみで保持し、QR・カート・HTMLには出さない。
// =============================================================
(function () {
  'use strict';

  // KIOSK_CONFIG はページ本体の <script>（このファイルの読み込みより後ろ）で定義されるため、
  // トップレベルでは参照しない。DOMContentLoaded 後（全 script 実行後）に init 内で取得する。
  let CFG = null;
  const KIOSK_TOKEN_KEY = 'bws_kiosk_token';
  const KIOSK_TOKEN_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 約3ヶ月（90日）。共有端末向けの保険。失効の主体はBWS側のtoken有効期限。

  // 依頼作成APIで受け取り、以降のステップで使う値
  let designToken = null;   // = _custom_design_token（注文紐付け用）
  let editToken = null;     // 画像アップロード用
  let claimUrlPath = null;  // QR用（App Proxy パス）
  let selectedVariants = [];   // 複数サイズ選択（選んだ順に保持）

  // ---- localStorage（消失・例外に耐える。保存時に有効期限を付与し、期限切れは無効化）----
  function getKioskToken() {
    try {
      const raw = localStorage.getItem(KIOSK_TOKEN_KEY);
      if (!raw) return null;
      let data = null;
      try { data = JSON.parse(raw); } catch (e) { data = null; }
      // 旧形式（文字列のみ）・不正データは破棄
      if (!data || typeof data !== 'object' || !data.token || !data.expiresAt) {
        localStorage.removeItem(KIOSK_TOKEN_KEY);
        return null;
      }
      // 期限切れは破棄（→ 起動時に再入力ゲートへ）
      if (Date.now() > data.expiresAt) {
        localStorage.removeItem(KIOSK_TOKEN_KEY);
        return null;
      }
      return data.token;
    } catch (e) { return null; }
  }
  function saveKioskToken(t) {
    try {
      const data = { token: t, expiresAt: Date.now() + KIOSK_TOKEN_TTL_MS };
      localStorage.setItem(KIOSK_TOKEN_KEY, JSON.stringify(data));
    } catch (e) { /* private mode 等 */ }
  }
  function clearKioskToken() {
    try { localStorage.removeItem(KIOSK_TOKEN_KEY); } catch (e) { /* noop */ }
  }

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    // KIOSK_CONFIG はページ本体の <script> で定義される。ここ（DOMContentLoaded後）なら参照可能。
    if (!window.KIOSK_CONFIG) {
      console.warn('kiosk: KIOSK_CONFIG が未定義です（テーマ設定・セクション配置を確認）');
      return;
    }
    CFG = window.KIOSK_CONFIG;

    const overlay = document.getElementById('kiosk-overlay');
    if (!overlay) {
      console.warn('kiosk: #kiosk-overlay が見つかりません');
      return;
    }

    // ---- 画面切り替え ----
    const screens = {};
    overlay.querySelectorAll('[data-kiosk-screen]').forEach(function (el) {
      screens[el.getAttribute('data-kiosk-screen')] = el;
    });
    function showOverlay() { overlay.hidden = false; }
    function hideOverlay() { overlay.hidden = true; }
    function showScreen(name) {
      Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
      showOverlay();
    }

    // ---- ゲート（kiosk_token 入力）----
    const tokenInput = document.getElementById('kiosk-token-input');
    const tokenSaveBtn = document.getElementById('kiosk-token-save');
    const gateError = document.getElementById('kiosk-gate-error');

    function showGate(message) {
      if (message) { gateError.textContent = message; gateError.hidden = false; }
      else { gateError.hidden = true; }
      if (tokenInput) tokenInput.value = '';
      showScreen('gate');
      if (tokenInput) tokenInput.focus();
    }

    if (tokenSaveBtn) {
      tokenSaveBtn.addEventListener('click', function () {
        const val = (tokenInput.value || '').trim();
        if (!val) {
          gateError.textContent = 'kiosk_token を入力してください。';
          gateError.hidden = false;
          return;
        }
        saveKioskToken(val);
        gateError.hidden = true;
        showSizeSelection();
      });
    }

    // ---- サイズ選択（1サイズ）----
    const sizeList = document.getElementById('kiosk-size-list');
    const sizeNextBtn = document.getElementById('kiosk-size-next');
    const sizeError = document.getElementById('kiosk-size-error');

    const sizeNextDefaultLabel = sizeNextBtn ? sizeNextBtn.textContent : 'デザイン作成へ';

    // 選択数に応じて「次へ」ボタンの活性・ラベルを更新
    function updateSizeNext() {
      const count = selectedVariants.length;
      sizeNextBtn.disabled = count === 0;
      sizeNextBtn.textContent = count === 0
        ? sizeNextDefaultLabel
        : '（' + count + 'サイズ）でデザイン作成へ';
    }

    function showSizeSelection() {
      selectedVariants = [];
      sizeError.hidden = true;
      sizeList.innerHTML = '';

      const product = CFG.product;
      if (!product || !product.variants || !product.variants.length) {
        sizeError.textContent = '商品（バリアント）が未設定です。テーマ設定で「カスタムTシャツ商品」を選択してください。';
        sizeError.hidden = false;
        showScreen('size');
        return;
      }

      product.variants.forEach(function (v) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kiosk-size-btn';
        btn.setAttribute('aria-pressed', 'false');

        // チェック（✓）＋サイズ名（デザイン: SizePicker）
        const check = document.createElement('span');
        check.className = 'kiosk-size-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        const label = document.createElement('span');
        label.className = 'kiosk-size-label';
        label.textContent = v.option1 || v.title;
        btn.appendChild(check);
        btn.appendChild(label);

        if (v.available === false) {
          btn.disabled = true;
          btn.title = '在庫なし';
        }
        // クリックでトグル（複数選択可）
        btn.addEventListener('click', function () {
          const idx = selectedVariants.indexOf(v);
          if (idx >= 0) {
            selectedVariants.splice(idx, 1);
            btn.setAttribute('aria-pressed', 'false');
          } else {
            selectedVariants.push(v);
            btn.setAttribute('aria-pressed', 'true');
          }
          updateSizeNext();
        });
        sizeList.appendChild(btn);
      });
      updateSizeNext();
      showScreen('size');
    }

    if (sizeNextBtn) {
      sizeNextBtn.addEventListener('click', function () {
        if (!selectedVariants.length) return;
        createDesignRequest();
      });
    }

    // ---- ローディング ----
    const loadingText = document.getElementById('kiosk-loading-text');
    function setLoading(msg) {
      if (loadingText && msg) loadingText.textContent = msg;
      showScreen('loading');
    }

    // ---- 依頼作成API（デザイン作成の前に呼ぶ。kiosk_token 検証＋403リカバリ）----
    async function createDesignRequest() {
      const kioskToken = getKioskToken();
      if (!kioskToken) { showGate('kiosk_token が未設定です。'); return; }

      setLoading('デザインの準備をしています…');
      try {
        const res = await fetch(CFG.proxyBase + '/shopify/custom-design-kiosk-requests', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            kiosk_token: kioskToken,
            product_type: CFG.productType || 'custom_tshirt',
            shopify_product_id: CFG.product.gid,
            shopify_product_handle: CFG.product.handle,
            variants: selectedVariants.map(function (v) {
              return {
                shopify_variant_id: v.gid,
                quantity: 1,
                title: v.title,
                sku: v.sku,
                option_values: { size: v.option1 }
              };
            })
          })
        });

        if (!res.ok) {
          // 403 は (a) App Proxy 署名検証の失敗 / (b) kiosk_token 無効・期限切れ の両方でありうる。
          // 切り分けのためレスポンス本文・実 URL を console に出す。
          let bodyText = '';
          try { bodyText = await res.text(); } catch (e) { /* noop */ }
          console.error('kiosk: 依頼作成API エラー', { status: res.status, url: res.url, body: bodyText });

          if (res.status === 403) {
            // 本文に token 系の語があるときだけ localStorage を破棄（署名失敗で有効 token を捨てない）。
            if (/token/i.test(bodyText)) {
              clearKioskToken();
              showGate('kiosk_token が無効または期限切れです。スタッフが再設定してください。');
            } else {
              sizeError.textContent = 'アクセスが拒否されました（403）。App Proxy 設定をスタッフにご確認ください（詳細はコンソール）。';
              sizeError.hidden = false;
              showScreen('size');
            }
            return;
          }
          throw new Error('依頼作成に失敗しました (HTTP ' + res.status + ')');
        }

        const json = await res.json();
        const data = json.data || json;
        designToken = data.token;
        editToken = data.edit_token;
        claimUrlPath = data.claim_url_path;

        if (!designToken || !editToken || !claimUrlPath) {
          throw new Error('依頼作成レスポンスが不正です');
        }

        // 成功 → オーバーレイを閉じてデザイン作成へ
        hideOverlay();
      } catch (err) {
        console.error('kiosk: 依頼作成エラー', err);
        sizeError.textContent = '通信エラーが発生しました。もう一度お試しください。';
        sizeError.hidden = false;
        showScreen('size');
      }
    }

    // ---- 「この内容で決定」→ 画像2枚生成 → アップロードAPI → QR表示 ----
    const confirmBtn = document.getElementById('designer-confirm-btn');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', onConfirm);
    }

    function onConfirm() {
      if (!designToken || !editToken) {
        alert('デザイン依頼が初期化されていません。最初からやり直してください。');
        return;
      }
      const D = window.__TSHIRT_DESIGNER__;
      if (!D || typeof D.exportPrintAreaAsPNG !== 'function') {
        alert('デザインエディタが初期化されていません。');
        return;
      }

      // #661 確定するとあとから編集できなくなるため、実行前に警告を出す
      if (D && typeof D.showConfirmDialog === 'function') {
        D.showConfirmDialog(
          'このまま進むとデザインが確定され、\nあとから編集できなくなります。\nよろしいですか？',
          runConfirmSave,
          { okLabel: 'この内容で決定する', cancelLabel: 'もどって編集する' }
        );
      } else {
        runConfirmSave();
      }
    }

    async function runConfirmSave() {
      const D = window.__TSHIRT_DESIGNER__;
      setLoading('デザインを保存しています…');
      try {
        const printBlob = await D.exportPrintAreaAsPNG(3000);  // 印刷用（15MB以下）
        const previewBlob = await D.exportPrintAreaAsPNG(800); // preview用（3MB以下・暫定解像度）
        if (!printBlob || !printBlob.size) throw new Error('画像生成に失敗しました');

        const fd = new FormData();
        fd.append('kiosk_token', getKioskToken() || '');
        fd.append('edit_token', editToken);
        fd.append('preview_image', previewBlob, 'preview.png');
        fd.append('print_image', printBlob, 'print.png');

        const res = await fetch(
          CFG.proxyBase + '/shopify/custom-design-kiosk-requests/' + encodeURIComponent(designToken) + '/assets',
          { method: 'POST', body: fd }
        );

        if (res.status === 403) {
          clearKioskToken();
          showGate('kiosk_token が無効になりました。スタッフが再設定してください。');
          return;
        }
        if (!res.ok) throw new Error('画像アップロードに失敗しました (HTTP ' + res.status + ')');

        // QR表示の前に注意事項を表示（確認ボタンでQRへ）
        showScreen('notice');
      } catch (err) {
        console.error('kiosk: アップロードエラー', err);
        alert('保存に失敗しました。もう一度「この内容で決定」を押してください。\n\n' + err.message);
        hideOverlay(); // エディタへ戻す
      }
    }

    // ---- QR表示（claim_url_path から App Proxy URL を生成）----
    const qrContainer = document.getElementById('kiosk-qr');
    const nextCustomerBtn = document.getElementById('kiosk-next-customer');

    function showQr() {
      const claimUrl = location.origin + claimUrlPath;
      qrContainer.innerHTML = '';
      try {
        const qr = qrcode(0, 'M');   // 型番自動・誤り訂正レベルM
        qr.addData(claimUrl);
        qr.make();
        qrContainer.innerHTML = qr.createImgTag(6, 8); // cellSize=6, margin=8（実寸はCSSで制御）
      } catch (e) {
        console.error('kiosk: QR生成エラー', e);
        qrContainer.textContent = 'QRコードの生成に失敗しました。スタッフにお知らせください。';
      }
      showScreen('qr');
    }

    // 注意事項画面の「確認」ボタン → QR表示
    const noticeNextBtn = document.getElementById('kiosk-notice-next');
    if (noticeNextBtn) {
      noticeNextBtn.addEventListener('click', showQr);
    }

    if (nextCustomerBtn) {
      nextCustomerBtn.addEventListener('click', function () {
        // 次のお客様へ：状態をリセットして再読込（kiosk_token は localStorage に残す）
        location.reload();
      });
    }

    // ---- 起動 ----
    if (getKioskToken()) {
      showSizeSelection();   // token あり → サイズ選択から
    } else {
      showGate();            // token なし → スタッフ入力ゲートから
    }
  }
})();
